module.exports = "/_next/static/images/aeacd704b8877e43c3d46abcd7deac28-credit-card-prepayment@0.5x.png.webp";